import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2efdbc84"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "product-list"
};
const _hoisted_2 = {
  class: "product-list__container"
};
const _hoisted_3 = {
  key: 0,
  class: "product-list__loading"
};
const _hoisted_4 = {
  key: 1,
  class: "product-list__empty"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "empty-content"
}, [/*#__PURE__*/_createElementVNode("h2", {
  class: "title"
}, [/*#__PURE__*/_createTextVNode("暂时没有匹配到相关的搜索结果，"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("您可以尝试：")]), /*#__PURE__*/_createElementVNode("ol", {
  class: "desc"
}, [/*#__PURE__*/_createElementVNode("li", null, "检查输入是否有误"), /*#__PURE__*/_createElementVNode("li", null, "变更搜索关键词")])], -1));
const _hoisted_6 = [_hoisted_5];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_product_item = _resolveComponent("product-item");
  const _component_recommend_search_questions = _resolveComponent("recommend-search-questions");
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.list.length || _ctx.loading || _ctx.moreDataLoading ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loading ? new Array(_ctx.skeletonNum) : _ctx.list, (product, index) => {
    var _product$id, _ctx$questionsMap;
    return _openBlock(), _createElementBlock(_Fragment, {
      key: (_product$id = product === null || product === void 0 ? void 0 : product.id) !== null && _product$id !== void 0 ? _product$id : index
    }, [_createVNode(_component_product_item, {
      item: product,
      loading: _ctx.loading,
      "log-info": {
        alias: _ctx.componentAlias,
        pos: index
      }
    }, null, 8, ["item", "loading", "log-info"]), product !== null && product !== void 0 && product.isPageEnd && (_ctx$questionsMap = _ctx.questionsMap) !== null && _ctx$questionsMap !== void 0 && (_ctx$questionsMap = _ctx$questionsMap[`page_${product === null || product === void 0 ? void 0 : product.page}`]) !== null && _ctx$questionsMap !== void 0 && _ctx$questionsMap.length ? (_openBlock(), _createBlock(_component_recommend_search_questions, {
      key: 0,
      "screen-type": 'mobile',
      list: _ctx.questionsMap[`page_${product === null || product === void 0 ? void 0 : product.page}`]
    }, null, 8, ["list"])) : _createCommentVNode("", true)], 64);
  }), 128))])), [[_directive_infinite_scroll, _ctx.onInfiniteScroll]]), _ctx.moreDataLoading ? (_openBlock(), _createElementBlock("div", _hoisted_3, "正在加载更多")) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))]);
}